import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import withIntl from "../../utils/withIntl";
import InhouseOrderLayoutEdit from "./Layouts/InhouseOrder/InhouseOrderLayoutEdit";
import InhouseBillLayoutEdit from "./Layouts/InhouseBill/InhouseBillLayoutEdit";
import TakeawayOrderLayoutEdit from "./Layouts/TakeawayOrder/TakeawayOrderLayoutEdit";
import TakeawayBillLayoutEdit from "./Layouts/TakeawayBill/TakeawayBillLayoutEdit";
import { makeStyles } from "@material-ui/core/styles";
import { useDialog } from "../Dialogs/DialogProvider";
import { updatePrinter } from "./PrinterApi";
import cloudStore from "../../store/CloudStore";
import PrinterTags from "./PrinterTags";
import MynbonnenUsers from "./MynbonnenUsers";
import PillarUsers from "./PillarUsers";

const parseLayoutOptions = (layoutOptions) => {
  if (layoutOptions == null) {
    layoutOptions = {};
  }
  if (layoutOptions.font_size_small == null) {
    layoutOptions.font_size_small = 48;
  }
  if (layoutOptions.font_size_medium == null) {
    layoutOptions.font_size_medium = 42;
  }
  if (layoutOptions.font_size_large == null) {
    layoutOptions.font_size_large = 24;
  }
  if (layoutOptions.font_size_huge == null) {
    layoutOptions.font_size_huge = 12;
  }
  if (layoutOptions.order == null) {
    layoutOptions.order = {};
  }
  if (layoutOptions.order.articlegroup_names_above_articles == null) {
    layoutOptions.order.articlegroup_names_above_articles = false;
  }
  if (layoutOptions.order.margin_top == null) {
    layoutOptions.order.margin_top = 0;
  }
  if (layoutOptions.order.margin_bottom == null) {
    layoutOptions.order.margin_bottom = 0;
  }
  if (layoutOptions.order.subtotal == null) {
    layoutOptions.order.subtotal = true;
  }

  if (layoutOptions.order_total_receipt == null) {
    layoutOptions.order_total_receipt = {};
  }
  if (layoutOptions.order_total_receipt.header == null) {
    layoutOptions.order_total_receipt.header = "";
  }
  if (layoutOptions.order_total_receipt.footer == null) {
    layoutOptions.order_total_receipt.footer = "";
  }

  if (layoutOptions.ta_order_total_receipt == null) {
    layoutOptions.ta_order_total_receipt = {};
  }

  if (layoutOptions.ta_order_total_receipt.header == null) {
    layoutOptions.ta_order_total_receipt.header = "";
  }
  if (layoutOptions.ta_order_total_receipt.footer == null) {
    layoutOptions.ta_order_total_receipt.footer = "";
  }

  if (layoutOptions.ta_order == null) {
    layoutOptions.ta_order = {};
  }
  if (layoutOptions.ta_order.print_client_details == null) {
    layoutOptions.ta_order.print_client_details = true;
  }
  if (layoutOptions.ta_order.print_delivery_costs == null) {
    layoutOptions.ta_order.print_delivery_costs = true;
  }
  if (layoutOptions.ta_order.print_payment_costs == null) {
    layoutOptions.ta_order.print_payment_costs = true;
  }
  if (layoutOptions.ta_order.print_total == null) {
    layoutOptions.ta_order.print_total = true;
  }
  if (layoutOptions.ta_order.hide_pickup_timestamp == null) {
    layoutOptions.ta_order.hide_pickup_timestamp = false;
  }
  if (layoutOptions.ta_order.article == null) {
    layoutOptions.ta_order.article = {
      lines: [{ elements: ["count", " x ", "print_name", "end_align", "money_sign", "price"], font_size: "medium" }],
    };
  }
  if (layoutOptions.order.article == null) {
    layoutOptions.order.article = {
      lines: [{ elements: ["count", " x ", "print_name", "end_align", "money_sign", "price"], font_size: "medium" }],
    };
  }
  if (layoutOptions.ta_order_total_receipt.article == null) {
    layoutOptions.ta_order_total_receipt.article = {
      lines: [{ elements: ["count", " x ", "print_name", "end_align", "money_sign", "price"], font_size: "medium" }],
    };
  }
  if (layoutOptions.ta_order_total_receipt.hide_pickup_timestamp == null) {
    layoutOptions.ta_order_total_receipt.hide_pickup_timestamp = false;
  }

  return layoutOptions;
};

const useStyles = makeStyles(() => ({
  rootActions: {
    justifyContent: "center",
  },
}));

function PrinterDetails(props) {
  const classes = useStyles();
  const [printer, setPrinter] = useState(props.printer);
  const [layoutOptions, setLayoutOptions] = useState(parseLayoutOptions(JSON.parse(printer.layout_options)));
  const [, closeDialog] = useDialog();

  return (
    <>
      <DialogTitle>
        {printer.description} - {printer.address}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          <Grid container item spacing={1} xs={6} lg={3}>
            <Grid item xs={4}>
              {props.intl.formatMessage({ id: "description" })}
            </Grid>
            <Grid item xs={8}>
              <TextField
                value={printer.description}
                onChange={(e) => {
                  printer.description = e.target.value;
                  setPrinter({ ...printer });
                }}
              />
            </Grid>
            <Grid item xs={4}>
              {props.intl.formatMessage({ id: "comment" })}
            </Grid>
            <Grid item xs={8}>
              <TextField
                value={printer.comment}
                onChange={(e) => {
                  printer.comment = e.target.value;
                  setPrinter({ ...printer });
                }}
              />
            </Grid>
            <Grid item xs={4}>
              {props.intl.formatMessage({ id: "printer_type" })}
            </Grid>
            <Grid item xs={8}>
              <TextField
                value={printer.type}
                onChange={(e) => {
                  printer.type = e.target.value;
                  setPrinter({ ...printer });
                }}
              />
            </Grid>
            <Grid item xs={4}>
              {props.intl.formatMessage({ id: "printer_sub_type" })}
            </Grid>
            <Grid item xs={8}>
              <TextField
                value={printer.sub_type}
                onChange={(e) => {
                  printer.sub_type = e.target.value;
                  setPrinter({ ...printer });
                }}
              />
            </Grid>
            <Grid item xs={4}>
              {props.intl.formatMessage({ id: "printer_address" })}
            </Grid>
            <Grid item xs={8}>
              <TextField
                value={printer.address}
                onChange={(e) => {
                  printer.address = e.target.value;
                  setPrinter({ ...printer });
                }}
              />
            </Grid>
            <Grid item xs={4}>
              {props.intl.formatMessage({ id: "is_bill_printer" })}
            </Grid>
            <Grid item xs={8}>
              <Checkbox
                color={"primary"}
                checked={!!printer.is_pin_printer}
                onChange={(e) => {
                  printer.is_pin_printer = !printer.is_pin_printer;
                  setPrinter({ ...printer });
                }}
              />
            </Grid>
            <Grid item xs={4}>
              Print number of inhouse bills
            </Grid>
            <Grid item xs={8}>
              <TextField
                color={"primary"}
                disabled={!printer.is_pin_printer}
                value={!!printer.is_pin_printer ? printer.print_count_inhouse_bills : 0}
                onChange={(e) => {
                  printer.print_count_inhouse_bills = parseInt(e.target.value);
                  setPrinter({ ...printer });
                }}
              />
            </Grid>
            <Grid item xs={4}>
              Print number of takeaway bills
            </Grid>
            <Grid item xs={8}>
              <TextField
                color={"primary"}
                disabled={!printer.is_pin_printer}
                value={!!printer.is_pin_printer ? printer.print_count_takeaway_bills : 0}
                onChange={(e) => {
                  printer.print_count_takeaway_bills = parseInt(e.target.value);
                  setPrinter({ ...printer });
                }}
              />
            </Grid>
            <Grid item xs={4}>
              General font size
            </Grid>
            <Grid item xs={2}>
              <Select
                value={layoutOptions.font_size_medium}
                onChange={(e) => {
                  layoutOptions.font_size_medium = e.target.value;
                  setLayoutOptions({ ...layoutOptions });
                }}
              >
                <MenuItem value={48}>Small</MenuItem>
                <MenuItem value={42}>Normal</MenuItem>
                <MenuItem value={24}>Large</MenuItem>
                <MenuItem value={12}>Huge</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={4}>
              Font number of columns small (48)
            </Grid>
            <Grid item xs={2}>
              <TextField
                value={layoutOptions.font_width_small}
                type={"number"}
                onChange={(e) => {
                  layoutOptions.font_width_small = !Number.isInteger(e.target.value)
                    ? e.target.value
                    : Number(e.target.value);
                  setLayoutOptions({ ...layoutOptions });
                }}
              />
            </Grid>
            <Grid item xs={4}>
              Table number font size
            </Grid>
            <Grid item xs={2}>
              <Select
                value={layoutOptions.font_size_large}
                onChange={(e) => {
                  layoutOptions.font_size_large = e.target.value;
                  setLayoutOptions({ ...layoutOptions });
                }}
              >
                <MenuItem value={48}>Small</MenuItem>
                <MenuItem value={42}>Normal</MenuItem>
                <MenuItem value={24}>Large</MenuItem>
                <MenuItem value={12}>Huge</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={4}>
              Font number of columns medium (24)
            </Grid>
            <Grid item xs={2}>
              <TextField
                value={layoutOptions.font_width_medium}
                type={"number"}
                onChange={(e) => {
                  layoutOptions.font_width_medium = !Number.isInteger(e.target.value)
                    ? e.target.value
                    : Number(e.target.value);
                  setLayoutOptions({ ...layoutOptions });
                }}
              />
            </Grid>
            <Grid item xs={4}>
              Custom font size 1
            </Grid>
            <Grid item xs={2}>
              <Select
                value={layoutOptions.font_size_small}
                onChange={(e) => {
                  layoutOptions.font_size_small = e.target.value;
                  setLayoutOptions({ ...layoutOptions });
                }}
              >
                <MenuItem value={48}>Small</MenuItem>
                <MenuItem value={42}>Normal</MenuItem>
                <MenuItem value={24}>Large</MenuItem>
                <MenuItem value={12}>Huge</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={4}>
              Font number of columns large (24)
            </Grid>
            <Grid item xs={2}>
              <TextField
                value={layoutOptions.font_width_large}
                type={"number"}
                onChange={(e) => {
                  layoutOptions.font_width_large = !Number.isInteger(e.target.value)
                    ? e.target.value
                    : Number(e.target.value);
                  setLayoutOptions({ ...layoutOptions });
                }}
              />
            </Grid>
            <Grid item xs={4}>
              Custom font size 2
            </Grid>
            <Grid item xs={2}>
              <Select
                value={layoutOptions.font_size_huge}
                onChange={(e) => {
                  layoutOptions.font_size_huge = e.target.value;
                  setLayoutOptions({ ...layoutOptions });
                }}
              >
                <MenuItem value={48}>Small</MenuItem>
                <MenuItem value={42}>Normal</MenuItem>
                <MenuItem value={24}>Large</MenuItem>
                <MenuItem value={12}>Huge</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={4}>
              Font number of columns huge (12)
            </Grid>
            <Grid item xs={2}>
              <TextField
                value={layoutOptions.font_width_huge}
                type={"number"}
                onChange={(e) => {
                  layoutOptions.font_width_huge = !Number.isInteger(e.target.value)
                    ? e.target.value
                    : Number(e.target.value);
                  setLayoutOptions({ ...layoutOptions });
                }}
              />
            </Grid>
          </Grid>
          <Grid item xs={6} lg={3}>
            <PrinterTags
              printer={printer}
              setPrinterTags={(printerTags) => {
                printer.printer_tags = printerTags;
                setPrinter({ ...printer });
              }}
            />
          </Grid>
          <Grid item xs={6} lg={3}>
            <MynbonnenUsers
              printer={printer}
              setMynbonnenUsers={(mynbonnenUsers) => {
                printer.mynbonnen_users = mynbonnenUsers;
                setPrinter({ ...printer });
              }}
            />
          </Grid>
          <Grid item xs={6} lg={3}>
            <PillarUsers
              printer={printer}
              setPillarUsers={(pillarUsers) => {
                printer.pillar_users = pillarUsers;
                setPrinter({ ...printer });
              }}
            />
          </Grid>
        </Grid>

        <InhouseOrderLayoutEdit
          layoutOptions={layoutOptions}
          setLayoutOptions={(layoutOptions) => {
            setLayoutOptions(layoutOptions);
          }}
        />
        <InhouseBillLayoutEdit
          layoutOptions={layoutOptions}
          setLayoutOptions={(layoutOptions) => {
            setLayoutOptions(layoutOptions);
          }}
        />
        <TakeawayOrderLayoutEdit
          layoutOptions={layoutOptions}
          setLayoutOptions={(layoutOptions) => {
            setLayoutOptions(layoutOptions);
          }}
        />
        <TakeawayBillLayoutEdit
          layoutOptions={layoutOptions}
          setLayoutOptions={(layoutOptions) => {
            setLayoutOptions(layoutOptions);
          }}
        />
      </DialogContent>
      <DialogActions classes={{ root: classes.rootActions }}>
        <Button
          variant={"outlined"}
          color={"primary"}
          onClick={() => {
            closeDialog();
          }}
        >
          {props.intl.formatMessage({ id: "cancel" })}
        </Button>
        <Button
          variant={"contained"}
          color={"primary"}
          onClick={() => {
            printer.layout_options = JSON.stringify(layoutOptions);
            updatePrinter(cloudStore.merchant.id, printer, printer).then((printer) => {
              props.onPrinterUpdate(printer);
              closeDialog();
            });
          }}
        >
          {props.intl.formatMessage({ id: "save" })}
        </Button>
      </DialogActions>
    </>
  );
}

export default withIntl(PrinterDetails);
